import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useAppDispatch, RootState} from "../../../redux/store";
import {theme} from "../../theme";


import {convertToDateTime} from "components/common/dateUtils/convertToDateTime";
import EngineeringIcon from '@mui/icons-material/Engineering';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import TaskIcon from '@mui/icons-material/Task';
import SendIcon from '@mui/icons-material/Send';


import {Ticket, saveTicket, deleteTicket, PrioritaTicketTypes, StatoTicketTypes} from "../ticketingSlice";

import ReactHookFormSelect from "../../common/ReactHookFormSelect";
import {
    Chip,
} from "@mui/material";
import {useForm, SubmitHandler,} from "react-hook-form";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import {Button,} from "@mui/material";
import {Alert} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CommentiCard from "../ticket/commenti/CommentiCard";
import {utenteAutorizzato} from "../../authentication/UtenteAutorizzato";
import {UtenteLogged} from "../../authentication/authenticationSlice";
import {PermissionTypes} from "../../authentication/permissionsGroups";
import {utenteFullName} from "../../authentication/UtenteFullName";
import {useAutorizzazioneGruppi} from "../../authentication/useAutorizzazioneGruppi";

interface TicketFormProps {
    ticket: Ticket;
    consentiModifica: boolean;
    viewOrdine?: boolean;
}

const TicketForm = ({
                        ticket,
                        consentiModifica = false,
                    }: TicketFormProps) => {
    const {
        handleSubmit,
        register,
        formState: {errors, isDirty, isValid},
        setValue,
        watch,
        getValues,
        control,
        setError,
        clearErrors,
        reset,
    } = useForm<Ticket>();

    const listaCampi = Object.keys(ticket) as Array<keyof Ticket>;

    const dispatch = useAppDispatch();


    const utenteLogged = useSelector<RootState, UtenteLogged>((state) => state.authentication.utenteLogged);

    useEffect(() => {
        reset(ticket);
    }, [ticket, reset]);

    useEffect(() => {
        clearErrors();
        listaCampi.forEach((field) => {
            ticket?.errorsStack?.fieldsErrors &&
            ticket.errorsStack.fieldsErrors[field] &&
            setError(field, {
                type: "server",
                message: ticket.errorsStack.fieldsErrors[field].toString(),
            });
        });
    }, [
        ticket?.errorsStack?.fieldsErrors,
        // cliente.allevamento_pack?.errorsStack?.fieldsErrors,
    ]);

    const handlerSaveTicket = (ticket: Ticket) => {
        consentiModifica && dispatch(saveTicket({ticketToSave: ticket}));
    };
    const [cardCommentiOpen, setCardCommentiOpen] = useState<boolean>(false);


    const onSubmit: SubmitHandler<Ticket> = (ticket) => {
        handlerSaveTicket(ticket);
    };

    const handlerDetailChangeSubmit = () => {
        if (isValid && isDirty) {
            const formValues = getValues();
            handlerSaveTicket(formValues);
        }
    };

    useEffect(() => {
        if (isValid && isDirty) {
            const formValues = getValues();
            handlerSaveTicket(formValues);
        }
    }, [watch("owner_id"), watch("data_apertura"), watch("data_presa_in_carico"), watch("priorita"), watch("data_risoluzione"), watch("data_chiusura")]);

    const assistenzaAutorizzata = useAutorizzazioneGruppi([PermissionTypes.TICKETING_ASSISTENZA]);

    return (
        <Box sx={{mb: 1}}>
            <form onSubmit={handleSubmit(onSubmit)}>
                {ticket?.errorsStack?.fieldsErrors?.non_field_errors && (
                    <Alert severity="error">
                        {ticket?.errorsStack?.fieldsErrors?.non_field_errors.toString()}
                    </Alert>
                )}

                <Grid
                    container
                    // spacing={{xs: 0.5, md: 1, lg: 2}}
                    // sx={{mb: 1}}
                >
                    <Grid size={{xs: 3, sm: 3, md: 2, lg: 1}}>
                        <Chip
                            sx={{
                                ml: 1,
                                color: "white",
                                backgroundColor: ticket.stato == "BOZZA"
                                    ? "gray"
                                    : ticket.stato == "APERTO"
                                        ? theme.palette.error.main
                                        : ticket.stato == "IN_LAVORAZIONE"
                                            ? theme.palette.warning.main
                                            : ticket.stato == "RISOLTO"
                                                ? "green"
                                                : theme.palette.info.main,
                                minWidth: 60
                            }}
                            label={ticket?.id}/>

                    </Grid>

                    <Grid size={{xs: 6, sm: 6, md: 6, lg: 3}}>
                        <TextField
                            // label="descrizione"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            size="small"
                            multiline={true}
                            rows={3}
                            required={true}
                            {...register("descrizione")}
                            onBlur={handlerDetailChangeSubmit}
                            disabled={!consentiModifica || ticket.stato != "BOZZA"}
                            error={!!errors?.descrizione}
                            helperText={errors?.descrizione?.message}
                            autoComplete={"off"}
                            sx={{
                                width: "100%",
                                pr: 1,
                            }}
                            fullWidth
                        />
                    </Grid>
                    <Grid size={{xs: 12, sm: 12, md: 6, lg: 1}}>
                        <ReactHookFormSelect
                            name="priorita"
                            // label="owner"
                            register={register}
                            control={control}
                            watch={watch}
                            size="small"

                            variant="outlined"
                            disabled={!consentiModifica || ticket.stato != "BOZZA"}
                            // required
                            error={errors?.priorita?.message}
                            sx={{width: "100%", pr: 1}}
                        >
                            {Object.entries(PrioritaTicketTypes).map(([key, value]) => {
                                return (
                                    <MenuItem key={key} value={key}>
                                        {value}
                                    </MenuItem>
                                )
                            })};
                        </ReactHookFormSelect>

                    </Grid>
                    <Grid size={{xs: 12, sm: 12, md: 6, lg: 1}}>
                        <Typography sx={{pt: 1}} textAlign={"center"}>
                            {Object.entries(StatoTicketTypes).find(([key, value]) => key === ticket?.stato)?.[1]}
                        </Typography>
                    </Grid>

                    <Grid size={{xs: 2}}>
                        <Grid container>
                            {/*<Grid size={{xs: 12, sm: 6, md: 6, lg: 4}}>*/}
                            {/*    <Typography sx={{pt: 1}}>*/}
                            {/*        {ticket.applicativo}*/}
                            {/*    </Typography>*/}
                            {/*</Grid>*/}
                            <Grid size={{xs: 12, sm: 6, md: 6, lg: 6}}>
                                <Typography sx={{pt: 1}} align="center">
                                    {ticket.autore_descrizione}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, sm: 6, md: 6, lg: 6}}>
                                <Typography sx={{pt: 1}}  align="center">
                                    {ticket.owner_descrizione}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{xs: 3}}>
                        <Grid container>
                            <Grid size={{xs: 12, sm: 12, md: 6, lg: 3}}>
                                <Typography sx={{pt: 1}} variant={"body2"}>
                                    {convertToDateTime(ticket.data_apertura)?.toFormat("dd/MM/yy HH:mm")}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, sm: 12, md: 6, lg: 3}}>
                                <Typography sx={{pt: 1}} variant={"body2"}>
                                    {convertToDateTime(ticket.data_presa_in_carico)?.toFormat("dd/MM/yy HH:mm")}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, sm: 12, md: 6, lg: 3}}>
                                <Typography sx={{pt: 1}} variant={"body2"}>
                                    {convertToDateTime(ticket.data_risoluzione)?.toFormat("dd/MM/yy HH:mm")}
                                </Typography>
                            </Grid>
                            <Grid size={{xs: 12, sm: 12, md: 6, lg: 3}}>
                                <Typography sx={{pt: 1}} variant={"body2"}>
                                    {convertToDateTime(ticket.data_chiusura)?.toFormat("dd/MM/yy HH:mm")}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid size={{xs: 12, sm: 6, md: 6, lg: 1}}>
                        {/*<Stack direction="row" justifyContent="space-around">*/}
                        <Box sx={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "flex-end",
                            alignItems: "flex-start",
                            height: "100%", // Per assicurarti che occupi tutta l'altezza del genitore, se necessario
                        }}>

                            {ticket.stato == "BOZZA" ? (
                                <Button
                                    size="small"
                                    color="info"
                                    onClick={() => {
                                        const formValues = getValues();
                                        if (formValues['descrizione']) {
                                            dispatch(saveTicket({
                                                ticketToSave: formValues,
                                                azione: "apri",
                                                autore_descrizione: utenteFullName(utenteLogged)

                                            }))
                                        }
                                    }}
                                    sx={{minWidth: 0}}
                                    disabled={!consentiModifica || !getValues("descrizione")}

                                >
                                    <Tooltip title="Apri ticket">
                                        <SendIcon/>
                                    </Tooltip>


                                </Button>
                            ) : (
                                <Button
                                    size="small"
                                    color="info"
                                    onClick={() => setCardCommentiOpen(!cardCommentiOpen)}
                                    sx={{minWidth: 0}}
                                >
                                    <Tooltip title="Vedi commenti">
                                        <ReceiptLongIcon/>
                                    </Tooltip>

                                </Button>
                            )}
                            {assistenzaAutorizzata && ticket.stato == "APERTO" && (
                                <Button
                                    size="small"
                                    color="info"
                                    onClick={() => {
                                        dispatch(saveTicket({
                                            ticketToSave: ticket,
                                            azione: "prendi_in_carico",
                                            autore_descrizione: utenteFullName(utenteLogged)
                                        }))
                                    }}
                                    sx={{minWidth: 0}}
                                >
                                    <Tooltip title="Prendi in carico">
                                        <EngineeringIcon/>
                                    </Tooltip>

                                </Button>
                            )}

                            {assistenzaAutorizzata && ticket.stato == "IN_LAVORAZIONE" && (
                                <Button
                                    size="small"
                                    color="info"
                                    onClick={() => {
                                        dispatch(saveTicket({
                                            ticketToSave: ticket,
                                            azione: "risolvi",
                                            autore_descrizione: utenteFullName(utenteLogged)
                                        }))
                                    }}
                                    sx={{minWidth: 0}}
                                >
                                    <Tooltip title="Risolvi">
                                        <EmojiObjectsOutlinedIcon/>
                                    </Tooltip>

                                </Button>
                            )}
                            {ticket.stato != "CHIUSO" && (
                                <Button
                                    size="small"
                                    color="info"
                                    onClick={() => {
                                        const formValues = getValues();
                                        dispatch(saveTicket({
                                            ticketToSave: formValues,
                                            azione: "chiudi",
                                            autore_descrizione: utenteFullName(utenteLogged)
                                        }))
                                    }}
                                    sx={{minWidth: 0}}
                                    disabled={!consentiModifica}
                                >
                                    <Tooltip title="Chiudi ticket">
                                        <TaskIcon/>
                                    </Tooltip>

                                </Button>
                            )}
                        </Box>
                        {/*</Stack>*/}

                    </Grid>
                </Grid>

            </form>
            {cardCommentiOpen &&
                <CommentiCard ticket={ticket} consentiModifica={consentiModifica}/>
            }
        </Box>
    );
};

export default TicketForm;
